export default "__VITE_ASSET__r0eusGAVA8rUp6jesbNpnA__"